import { render, staticRenderFns } from "./honour.vue?vue&type=template&id=72df2e99&"
import script from "./honour.vue?vue&type=script&lang=js&"
export * from "./honour.vue?vue&type=script&lang=js&"
import style0 from "./honour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports